import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { DashboardData } from '../interfaces/Dashboard';

export async function getDashboard(): Promise<StandardResponse<DashboardData>> {
    const response: AxiosResponse<StandardResponse<DashboardData>> = await api.get("/preboard/me/dashboard", {
        params: {
            limit: 10,
        }
    });
    return response.data;
}